import { useEffect } from 'react';
import AIheader from '../RentAI/AIheader'
import Footer from '../../Component/Footer/Footer';
import './BlogsPage.css';

const BlogsPage = ()=> {

    useEffect(() => {
        const carousel = document.getElementById('demo');
    
        const handleSlide = () => {
            const activeItem = document.querySelector('#demo .carousel-item.active');
            const indicatorsContainer = document.querySelector('#demo .carousel-indicators');
    
            if (activeItem && indicatorsContainer) {
                const items = Array.from(document.querySelectorAll('#demo .carousel-item'));
                const activeIndex = items.indexOf(activeItem);
    
                if (activeIndex === 0) {
                    indicatorsContainer.classList.add('first-slide-active');
                } else {
                    indicatorsContainer.classList.remove('first-slide-active');
                }
                if (activeIndex === 2) {
                    indicatorsContainer.classList.add('third-slide-active');
                } else {
                    indicatorsContainer.classList.remove('third-slide-active');
                }
            }
        };
    
        carousel.addEventListener('slid.bs.carousel', handleSlide);
    
        // Run once initially
        handleSlide();
    
        return () => {
            carousel.removeEventListener('slid.bs.carousel', handleSlide);
        };
    }, []);
    
    return (
        <>
<AIheader/>

{/* START bannerBlogMain */}
<section className="bannerBlogMain">
    <div className="bannerBlogOuter">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="bannerBlogInner">
                        <div id="demo" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#demo" data-bs-slide-to="0" className="active"></button>
                                <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button> 
                                <button type="button" data-bs-target="#demo" data-bs-slide-to="2"></button>
                            </div>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="imgBanner" src="/img/blog/airbnbTuroHostsBanner.png" alt="rent id" />
                                    <div className="carousel-caption">
                                        <div className="blogHeading">
                                            <img width="17px" src="/img/blog/blog_icon.svg" alt="icon" />
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item active" aria-current="page">Blog</li>
                                            </ol>
                                        </div>
                                        <h1>How Airbnb & Turo Hosts Can Offer Car Rentals with Rentid</h1>
                                        <p>You’ve built a great brand on Airbnb—now you can extend it with your own car rental business.</p>
                                        <a href="/airbnb-turo-hosts" className="btn btnTransparent_3">Read more 
                                            <img width="24px" src="/img/blog/arrow-right-btn.svg" alt="icon"/>
                                        </a>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <img className="imgBanner" src="/img/blog/RentVehiclestoRideshareBanner.png" alt="rent id" />
                                    <div className="carousel-caption">
                                        <div className="blogHeading">
                                            <img width="17px" src="/img/blog/blog_icon.svg" alt="icon" />
                                            <small>Blog</small>
                                        </div>
                                        <h1>Rent Vehicles to Rideshare & Delivery Drivers Directly from Your Website</h1>
                                        <p>Take control of your rental business. As demand for gig-ready rentals skyrockets, 
                                            RentDirect empowers you to rent vehicles directly to rideshare.</p>
                                        <a href="/rent-vehicles-to-rideshare" className="btn btnTransparent_3">Read more 
                                        <img width="24px" src="/img/blog/arrow-right-btn.svg" alt="icon"/>
                                        </a>
                                    </div> 
                                </div>
                                <div className="carousel-item">
                                    <img className="imgBanner" src="/img/blog/rentShieldEmpowerBanner.jpg" alt="rent id" />
                                    <div className="carousel-caption">
                                        <div className="blogHeading">
                                            <img width="17px" src="/img/blog/blog_icon.svg" alt="icon" />
                                            <small>Blog</small>
                                        </div>
                                        <h1>How RentShield Empowers Hosts to Rent Vehicles to Gig and Delivery Drivers</h1>
                                        <p>In a world where flexibility fuels the workforce, gig and delivery drivers are 
                                            driving demand for rental vehicles like never before.</p>
                                        <a href="/rentshield-empowers" className="btn btnTransparent_3">Read more 
                                        <img width="24px" src="/img/blog/arrow-right-btn.svg" alt="icon"/>
                                        </a>
                                    </div> 
                                </div>
                            </div>

                            <button className="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon"></span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                                <span className="carousel-control-next-icon"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
{/* END bannerBlogMain */}



{/* START recentBlogMain  */}
<section className="recentBlogMain">
    <div className="container">
        <div className="recentBlogTop">
            <div className="row">
                <div className="col-lg-12">
                    <div className="headRecentBlog">
                        <h2>Most recent</h2>
                    </div>
                </div>
            </div>
            <div className='recentBlogOuter'>
            <a href='/airbnb-turo-hosts'>
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                        <div className='recentBlogLeft'>
                            <figure>
                                <img className="img-fluid" src="/img/blog/airbnbTuroHostsBanner.png"  alt="blog" />
                            </figure>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                        <div className='recentBlogRight'>
                            <h2>How Airbnb & Turo Hosts Can Offer Car Rentals with Rentid</h2>
                            <p>You’ve built a great brand on Airbnb—now you can extend it with your own car rental business. Whether you host one property or manage multiple listings, your guests need more than a place to stay—they need a way to get around. With Rentid, you can offer car rentals directly to your guests and build a travel experience that’s 100% yours.</p>
                            <div className='recentBlogRightBtn'>
                                <a href='/airbnb-turo-hosts'>5 mins read</a>
                            </div>
                            <small>Published May 13, 2025</small>
                        </div>
                    </div>
                </div>
            </a>
            </div>
        </div>
    </div>
</section>
{/* END recentBlogMain */}


{/* START blogMain */}
<section className="blogMain">
	<div className="container">
        <div className="recentBlogTop">
            <div className="row">
                <div className="col-lg-12">
                    <div className="headBlog">
                        <h2>How-To Guides</h2>
                    </div>
                </div>
            </div>

            <div className="row">

                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/rent-vehicles-to-rideshare">
                        <figure>
                            <img className="img-fluid" src="/img/blog/RentVehiclestoRideshareBanner.png" alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>Rent Vehicles to Rideshare & Delivery Drivers Directly from Your Website</h3>
                            <p>Take control of your rental business. As demand for gig-ready rentals skyrockets, RentDirect empowers you to rent vehicles directly to rideshare and delivery drivers from your own website—no commissions, no middlemen, and full protection with RentShield. Here's how you can build a scalable, independent rental operation for the modern mobility economy.</p>
                            <span>Published 5/5/25</span>
                        </div> 
                        </a>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/rentshield-empowers">
                        <figure>
                            <img className="img-fluid" src="/img/blog/rentShieldEmpowerBanner.jpg" alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>How RentShield Empowers Hosts to Rent Vehicles to Gig and Delivery Drivers</h3>
                            <p>In a world where flexibility fuels the workforce, gig and delivery drivers are driving 
                            demand for rental vehicles like never before. But with that opportunity comes risk — 
                            especially when it comes to insurance. That’s where RentShield steps in.</p>
                            <span>Published 4/28/25</span>
                        </div> 
                        </a>
                    </div>
                </div>



                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/fleet-operators">
                            <figure>
                                <img className="img-fluid" src="/img/blog/guide_4.png" alt="blog" />
                            </figure>
                            <div className="blogData">
                                <h3>The Unfortunate Fall of GetAround and HyreCar: What’s Next for Fleet Operators?</h3>
                                <p>For thousands of fleet operators and car-sharing hosts, the recent shutdown of Getaround and HyreCar is more than just industry news—it’s deeply personal. It represents lost income, broken trust, and an uncertain future for hardworking individuals who built their businesses on these platforms. As the dust settles, one pressing question remains: What’s next?</p>
                                <span>Published 3/04/25</span>
                            </div> 
                        </a>
                    </div>
                </div> 

                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/maximum-booking">
                        <figure>
                            <img className="img-fluid" src="/img/blog/guide_1.png" alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>How to Optimize Your Vehicle Listing for Maximum Bookings</h3>
                            <p>In the world of car rental platforms, standing out is key to ensuring your vehicle gets noticed and booked by potential renters.</p>
                            <span>Published 2/28/25</span>
                        </div> 
                        </a>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/identity-verification">
                        <figure>
                            <img className="img-fluid" src="/img/blog/guide_2.png" alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>The Importance of Identity Verification in Car Rentals</h3>
                            <p>In the fast-paced world of car rentals, ensuring the safety and security of both the business and 
                            its customers is of utmost importance. Identity verification is a crucial component in achieving this goal, 
                            serving as the first line of defense against fraud, unauthorized access, and potential liabilities.</p>
                            <span>Published 2/26/25</span>
                        </div> 
                        </a>
                    </div>
                </div>

           
            </div>
		</div>

	</div>
</section>
{/* END blogMain */}

<Footer/>
        </>
    )
}

export default BlogsPage;